import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="p-6 text-center">
      <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
      <p className="mb-4">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/home" className="text-blue-600 hover:underline">
        Go to Home
      </Link>
    </div>
  );
}

export default NotFound;
